export const ROUTE_BUILDERS = {

    BUILDING: { EDIT: (id) => `/building/edit/${id}`, },

    RENTAL_PROPERTY: { EDIT: (id) => `/rental-property/edit/${id}`, },

    TENANT: { EDIT: (id) => `/tenant/edit/${id}`, },

    INVOICE: { EDIT: (id) => `/invoice/edit/${id}`, },

    MEASUREMENT_UNIT: { EDIT: (id) => `/measurement-unit/edit/${id}`, },
};